<br><br>
<!-- <br><br> -->

<div class="section d-flex flex-column align-items-center justify-content-center" style="width: 100%;" #pdfContent
    id="invoicepdfdownload">
    <div class="row" id="print" style="width: 100%;">
        <div class="section d-flex flex-column align-items-center page-break" *ngFor="let a of receivedData">
            <div class="singleCard">
                <div>
                    <img src="assets/img/mepma/idbanner.jpg" alt="" height="110px" width="100%">
                    <div style="position: relative;">
                        <canvas id="qr-code{{a.id}}"
                            style="position: absolute;top: -30px;right:5px;background: white;width: 47px"></canvas>
                    </div>
                    <div class="card-body" style="font-size: 13px;padding: 1px 0px !important;margin-top: 18px;">
                        <table style="width: 90%;">
                            <tr>
                                <td rowspan="7"
                                    style="text-align: center; padding: 5px; position: relative;vertical-align: top;">
                                    <img src="{{a.image}}" alt="" class="imgcss" id="profileImage">
                                </td>
                                <td class="wid">Name:</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{
                                    a.user_name | uppercase| slice:0:45 }}{{ a.user_name.length > 45 ?
                                    '...' : '' }}</td>
                            </tr>

                            <tr>
                                <td class="wid">Aadhar ID</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ a.aadhaar_number }}</td>
                            </tr>
                            <tr>
                                <td class="wid">Mela Date</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ melaDetails?.mela_date | date:'dd-MM-yyyy' }}</td>
                            </tr>

                            <tr>
                                <td class="wid">Location</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ melaDetails?.district_name}}</td>
                            </tr>
                            <tr>
                                <td class="wid">District</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ melaDetails?.district_name}}</td>
                            </tr>


                            <!-- <tr>
                                <td class="wid" *ngIf="a.type_of_id_card == 'Duty-Pass'">Contractor</td>
                                <td class="wid" *ngIf="a.type_of_id_card != 'Duty-Pass'">Department</td>
                                <td class="wid2">:</td>
                                <td class="wid3">{{ a.department | uppercase | slice:0:45 }}{{ a.department.length > 45
                                    ?
                                    '...' : '' }}</td>
                            </tr>
                            <tr>
                                <td class="wid" *ngIf="a.type_of_id_card == 'Duty-Pass'">Department</td>
                                <td class="wid" *ngIf="a.type_of_id_card != 'Duty-Pass'">Duty Point</td>
                                <td class="wid2">:</td>
                                <td class="wid3" *ngIf="a.type_of_id_card == 'Duty-Pass' "><span
                                        *ngIf="a.duty_point != 'null' ">{{a.duty_point |
                                        uppercase}}</span>
                                </td>
                                <td class="wid4" *ngIf="a.type_of_id_card != 'Duty-Pass' "><span
                                        *ngIf="a.duty_point != 'null' ">{{a.duty_point.length <
                                            57?a.duty_point:`${a.duty_point.slice(0,57)}...` | titlecase}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="wid">Shift Time</td>
                                <td class="wid2">:</td>
                                <td class="wid3"><span *ngIf="a.shift_time != 'null'">{{a.shift_time |
                                        uppercase}}</span>
                                </td>
                            </tr> -->
                            <!-- <tr
                                *ngIf="a.type_of_id_card == 'This Temple STAFF ON DUTY' || a.type_of_id_card == 'OFFICER ON DUTY' || a.two_wheeler == true">
                                <td colspan="3"
                                    style="color: red; font-size: 8px; font-style: italic;font-weight: 900;">TWO WHEELER
                                    ALLOWED
                                    DUTY POINT</td>
                            </tr> -->
                            <!-- <tr
                                *ngIf="a.type_of_id_card != 'This Temple STAFF ON DUTY' || a.type_of_id_card != 'OFFICER ON DUTY' || a.two_wheeler == false">
                                <td colspan="3" style="color: red; font-size: 8px; font-style: italic;">&nbsp;</td>
                            </tr> -->
                            <tr>
                                <td>
                                    <!-- <img src="assets/sdms_icons/eo.png" alt="" width="47px" height="25px"
                                        style="position: absolute;left: 64%; width: 137px;height: 46px;bottom: 28px;transform: rotate(-5deg)"> -->

                                    <!-- <span style="position: absolute;left: 75%;top: 88%;font-size: 8px;" *ngIf="a.department.length >= '24'">{{date}}</span> -->


                                    <!-- <span style="position: absolute;left: 75%;top: 85%;font-size: 8px;" *ngIf="a.department.length < 24">{{date}}</span> -->

                                </td>
                            </tr>
                        </table>
                        <br>
                        <table style="width: 100%;position: absolute;bottom: 0px;">
                            <tr *ngIf="a.type_of_id_card == 'This Temple STAFF ON DUTY' || a.type_of_id_card == 'OFFICER ON DUTY'"
                                style="display: flex;text-align: center;justify-content: space-between;margin-top: -10px;">
                            <tr *ngIf="a.type_of_id_card != 'This Temple STAFF ON DUTY' || a.type_of_id_card != 'OFFICER ON DUTY'"
                                style="display: flex;text-align: center;justify-content: space-between;position: relative;">

                                <td style="font-size: 8px;"> <b>Signature of the Officer</b><br>
                                    <i>(To be signed after verification.)</i>
                                </td>
                                <span style="position: absolute;right: 10px;;font-size: 8px;">{{date}}</span>
                                <!-- <img src="assets/sdms_icons/eo.png" alt=""
                                    style="position: absolute;right: 10px;bottom: 7px; width: 127px;height: 40px;transform: rotate(-5deg)"> -->

                            </tr>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="button-container" style="display: flex; justify-content: center;gap: 20px;margin-top: 20px;"
        id="showprint">
        <button class="btn btn-primary" (click)="downloadinvoicepdf()">Download</button>
        <!-- <button class="btn btn-primary" (click)="Back()">Back</button> -->
    </div>
</div>

<!-- CSS -->
<!-- <style></style>
<style></style> -->